/**
 * Frontend network configuration. DEFAULT = same-origin (no production host is
 * baked into the build): API calls go to `/api/...` and WebSockets to
 * `wss?://<current-host>/ws/...`, so the app targets whatever origin served it
 * (staging on staging, production on production). Build-time overrides
 * REACT_APP_API_BASE / REACT_APP_WS_BASE are supported but must NOT point a
 * staging build at production (fail-closed below). Frontend env is PUBLIC
 * config — never put secrets here.
 */
export const API_BASE = process.env.REACT_APP_API_BASE || ''; // '' => same-origin

export function wsUrl(path) {
  if (process.env.REACT_APP_WS_BASE) return process.env.REACT_APP_WS_BASE + path;
  const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
  const host = typeof window !== 'undefined' ? window.location.host : 'localhost';
  return (isHttps ? 'wss://' : 'ws://') + host + path;
}

// FAIL-CLOSED: a staging build must never target production.
const PROD_MARKERS = ['888banya.kz', '82.115.49.105'];
export function assertNoProductionTarget(env, apiBase, wsBase) {
  if (env !== 'staging') return;
  for (const t of [apiBase || '', wsBase || '']) {
    if (PROD_MARKERS.some((m) => String(t).includes(m))) {
      throw new Error('FAIL-CLOSED: staging build targets production endpoint: ' + t);
    }
  }
}
assertNoProductionTarget(
  process.env.REACT_APP_ENV,
  process.env.REACT_APP_API_BASE,
  process.env.REACT_APP_WS_BASE
);
